document.addEventListener('DOMContentLoaded', initCardOverlayAdd);
document.addEventListener('shopify:section:load', initCardOverlayAdd);

function initCardOverlayAdd() {
  const isEnglish = window.location.pathname.startsWith('/en');
  const cards = document.querySelectorAll('.card__container');

  cards.forEach((card) => {
    const picture = card.querySelector('.card__picture-container');
    const quickAddWrap = card.querySelector('.card__quick-add-container');
    const originalButton = quickAddWrap?.querySelector('button');

    if (!picture || !originalButton) return;

    const existing = picture.querySelector('.card-overlay-add');
    if (existing) existing.remove();

    const overlayBtn = document.createElement('button');
    overlayBtn.type = 'button';
    overlayBtn.className = 'card-overlay-add';
    if (isEnglish) overlayBtn.classList.add('is-en');

    overlayBtn.setAttribute(
      'aria-label',
      originalButton.getAttribute('aria-label') || 'Add to cart'
    );

    const icon = document.createElement('img');
    icon.className = 'card-overlay-add__icon';
    icon.src = 'https://cdn.shopify.com/s/files/1/0752/8192/4143/files/Cart_icon_02.svg?v=1777845093';
    icon.alt = '';
    icon.setAttribute('aria-hidden', 'true');
    overlayBtn.appendChild(icon);

    syncOverlayState(card, overlayBtn);

    overlayBtn.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopPropagation();

      syncOverlayState(card, overlayBtn);

      if (
        overlayBtn.disabled ||
        overlayBtn.classList.contains('is-disabled') ||
        overlayBtn.classList.contains('is-stock-error')
      ) {
        return;
      }

      try {
        overlayBtn.disabled = true;
        overlayBtn.classList.remove('is-stock-error');
        overlayBtn.classList.add('is-loading');

        const currentForm = getCurrentAddToCartForm(card);

        if (currentForm && typeof window.silentAddFormToCart === 'function') {
          await validateCardStockBeforeAdd(card, currentForm);
          await window.silentAddFormToCart(currentForm);

          overlayBtn.classList.remove('is-loading');
          showAddFeedback(overlayBtn);
          await afterCardAddToCart();
          return;
        }

        const currentHandle = getCurrentProductHandle(card);

        if (currentHandle && typeof window.silentAddSiblingByHandle === 'function') {
          await validateCardStockBeforeAdd(card, null);
          await window.silentAddSiblingByHandle(currentHandle);

          overlayBtn.classList.remove('is-loading');
          showAddFeedback(overlayBtn);
          await afterCardAddToCart();
          return;
        }

        const currentUrl = getCurrentProductUrl(card);

        if (currentUrl) {
          window.location.href = currentUrl;
          return;
        }
      } catch (error) {
        console.error(error);
        showCardAddError(overlayBtn, error);
      } finally {
        overlayBtn.disabled = false;
        overlayBtn.classList.remove('is-loading');
        syncOverlayState(card, overlayBtn);
      }
    });

    picture.appendChild(overlayBtn);
  });
}

function getCurrentQuickAddWrap(card) {
  return card.querySelector('.card__quick-add-container');
}

function getCurrentOriginalButton(card) {
  const quickAddWrap = getCurrentQuickAddWrap(card);
  return quickAddWrap?.querySelector('button') || null;
}

function getCurrentAddToCartForm(card) {
  const quickAddWrap = getCurrentQuickAddWrap(card);
  return quickAddWrap?.querySelector('form[action*="/cart/add"]') || null;
}

function getCurrentProductHandle(card) {
  const quickAddWrap = getCurrentQuickAddWrap(card);
  const quickAdd = quickAddWrap?.querySelector('quick-add[data-product-handle]');
  const quickAddHandle = quickAdd?.getAttribute('data-product-handle');

  if (quickAddHandle) return quickAddHandle;

  const activeSwatch = card.querySelector('.color-swacther--wrapper.active .color-swacther');
  const activeSwatchHandle = activeSwatch?.getAttribute('data-product-handle');

  if (activeSwatchHandle) return activeSwatchHandle;

  return null;
}

function getCurrentProductUrl(card) {
  const activeSwatch = card.querySelector('.color-swacther--wrapper.active .color-swacther');
  const activeHref = activeSwatch?.getAttribute('data-href');

  if (activeHref) return activeHref;

  const productLink = card.querySelector('.card__picture-container a[href]');
  return productLink?.getAttribute('href') || null;
}

function syncOverlayState(card, overlayBtn) {
  const quickAddWrap = getCurrentQuickAddWrap(card);
  const currentButton = quickAddWrap?.querySelector('button');

  const isDisabled =
    !currentButton ||
    currentButton.disabled ||
    currentButton.hasAttribute('disabled');

  overlayBtn.classList.toggle('is-disabled', isDisabled);
  overlayBtn.disabled = isDisabled;

  if (currentButton) {
    overlayBtn.setAttribute(
      'aria-label',
      currentButton.getAttribute('aria-label') || 'Add to cart'
    );
  }
}

function showAddFeedback(button) {
  button.disabled = false;
  button.style.pointerEvents = 'auto';
  button.classList.remove('is-stock-error');
  button.classList.add('is-added');

  clearTimeout(button._addedTimeout);

  button._addedTimeout = setTimeout(() => {
    button.classList.remove('is-added');
  }, 1200);
}

async function validateCardStockBeforeAdd(card, form) {
  const stockData = getCardStockData(card, form);

  if (!stockData) return;
  if (!shouldLimitByStock(stockData)) return;

  const cartQuantity = await getCartQuantityForVariant(stockData.variantId);
  const addQuantity = getAddQuantityFromForm(form);

  if (cartQuantity + addQuantity > stockData.inventoryQuantity) {
    const message = getStockLimitMessage(stockData.inventoryQuantity);
    throw new Error(message);
  }
}

function getCardStockData(card, form) {
  const originalButton = getCurrentOriginalButton(card);
  const variantInput = form?.querySelector('[name="id"]') || null;

  const variantId =
    variantInput?.dataset.variantId ||
    variantInput?.value ||
    form?.dataset.variantId ||
    originalButton?.dataset.variantId ||
    '';

  const inventoryQuantityRaw =
    variantInput?.dataset.inventoryQuantity ||
    form?.dataset.inventoryQuantity ||
    originalButton?.dataset.inventoryQuantity ||
    '';

  const inventoryPolicy =
    variantInput?.dataset.inventoryPolicy ||
    form?.dataset.inventoryPolicy ||
    originalButton?.dataset.inventoryPolicy ||
    '';

  const inventoryManagement =
    variantInput?.dataset.inventoryManagement ||
    form?.dataset.inventoryManagement ||
    originalButton?.dataset.inventoryManagement ||
    '';

  if (!variantId) return null;

  const inventoryQuantity = parseInt(inventoryQuantityRaw, 10);

  return {
    variantId: String(variantId),
    inventoryQuantity,
    inventoryPolicy,
    inventoryManagement
  };
}

function shouldLimitByStock(stockData) {
  if (!stockData) return false;
  if (!stockData.inventoryManagement) return false;
  if (stockData.inventoryPolicy === 'continue') return false;
  if (!Number.isFinite(stockData.inventoryQuantity)) return false;

  return true;
}

function getAddQuantityFromForm(form) {
  if (!form) return 1;

  const quantityInput = form.querySelector('[name="quantity"]');
  const quantity = parseInt(quantityInput?.value || '1', 10);

  if (!Number.isFinite(quantity) || quantity < 1) return 1;

  return quantity;
}

async function getCartQuantityForVariant(variantId) {
  const response = await fetch('/cart.js', {
    headers: {
      Accept: 'application/json'
    }
  });

  if (!response.ok) return 0;

  const cart = await response.json().catch(() => null);

  if (!cart || !Array.isArray(cart.items)) return 0;

  return cart.items.reduce((total, item) => {
    if (String(item.variant_id) === String(variantId)) {
      return total + Number(item.quantity || 0);
    }

    return total;
  }, 0);
}

function getStockLimitMessage(quantity) {
  const rawMessage = window.cartStrings?.quantityError || window.cartStrings?.error || '';
  const withQuantity = rawMessage.replace('[quantity]', quantity);

  return stripHtml(withQuantity);
}

function stripHtml(value) {
  if (!value) return '';

  const div = document.createElement('div');
  div.innerHTML = value;

  return div.textContent || div.innerText || '';
}

function showCardAddError(button, error) {
  const message = getCardAddErrorMessage(error);

  button.classList.remove('is-loading');
  button.classList.remove('is-added');
  button.classList.add('is-stock-error');

  clearTimeout(button._stockErrorTimeout);

  button._stockErrorTimeout = setTimeout(() => {
    button.classList.remove('is-stock-error');
  }, 1800);

  if (message) {
    showCardAddToast(message);
  }
}

function getCardAddErrorMessage(error) {
  const message = typeof error === 'string' ? error : error?.message;

  if (message && message.trim() !== '') {
    return message;
  }

  if (window.cartStrings?.error) {
    return stripHtml(window.cartStrings.error);
  }

  return '';
}

function getCardAddToast() {
  let toast = document.querySelector('[data-card-add-toast]');

  if (toast) return toast;

  toast = document.createElement('div');
  toast.className = 'card-add-toast';
  toast.setAttribute('data-card-add-toast', '');
  toast.setAttribute('role', 'alert');
  toast.setAttribute('aria-live', 'polite');

  toast.innerHTML = `
    <span class="card-add-toast__icon" aria-hidden="true">!</span>
    <span class="card-add-toast__message"></span>
  `;

  document.body.appendChild(toast);

  return toast;
}

function showCardAddToast(message) {
  const toast = getCardAddToast();
  const messageEl = toast.querySelector('.card-add-toast__message');

  if (!messageEl) return;

  messageEl.textContent = message;

  clearTimeout(toast._hideTimeout);

  toast.classList.add('is-visible');

  toast._hideTimeout = setTimeout(() => {
    toast.classList.remove('is-visible');
  }, 4000);
}


/* Product card mobile image swipe */
document.addEventListener('DOMContentLoaded', initProductCardSwipe);
document.addEventListener('shopify:section:load', initProductCardSwipe);

function initProductCardSwipe() {
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  const cards = document.querySelectorAll('.card__container');

  cards.forEach((card) => {
    if (card.dataset.swipeBound === 'true') return;

    const picture = card.querySelector('.card__picture');
    const mainImage = picture?.querySelector('.card__img:not(.card__img--hover)');
    const hoverImage = picture?.querySelector('.card__img--hover');

    if (!picture || !mainImage || !hoverImage) return;

    card.dataset.swipeBound = 'true';
    picture.classList.add('has-card-swipe');

    addSwipeIndicator(picture);
    bindSiblingSwipeUpdate(card, picture, hoverImage);

    let startX = 0;
    let startY = 0;
    let isMoving = false;

    picture.addEventListener('touchstart', function (e) {
      if (!e.touches || e.touches.length !== 1) return;

      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isMoving = true;
    }, { passive: true });

    picture.addEventListener('touchend', function (e) {
      if (!isMoving || !e.changedTouches || e.changedTouches.length !== 1) return;

      const endX = e.changedTouches[0].clientX;
      const endY = e.changedTouches[0].clientY;

      const diffX = endX - startX;
      const diffY = endY - startY;

      isMoving = false;

      if (Math.abs(diffX) < 35) return;
      if (Math.abs(diffX) < Math.abs(diffY)) return;

      const isRTL = document.documentElement.getAttribute('dir') === 'rtl';

      if (isRTL) {
        if (diffX > 0) {
          picture.classList.add('is-swiped');
        } else {
          picture.classList.remove('is-swiped');
        }
      } else {
        if (diffX < 0) {
          picture.classList.add('is-swiped');
        } else {
          picture.classList.remove('is-swiped');
        }
      }
    }, { passive: true });
  });
}

function addSwipeIndicator(picture) {
  if (picture.querySelector('.card__swipe-indicator')) return;

  const indicator = document.createElement('div');
  indicator.className = 'card__swipe-indicator';
  indicator.setAttribute('aria-hidden', 'true');
  indicator.innerHTML = `
    <span class="card__swipe-dot"></span>
    <span class="card__swipe-bar"></span>
  `;

  picture.appendChild(indicator);
}

function bindSiblingSwipeUpdate(card, picture, hoverImage) {
  const swatches = card.querySelectorAll('.color-swatcher[data-hover]');

  swatches.forEach((swatch) => {
    if (swatch.dataset.swipeSiblingBound === 'true') return;
    swatch.dataset.swipeSiblingBound = 'true';

    swatch.addEventListener('click', function () {
      setTimeout(() => {
        updateSwipeHoverImageFromSwatch(swatch, picture, hoverImage);
      }, 80);
    });
  });
}

function updateSwipeHoverImageFromSwatch(swatch, picture, hoverImage) {
  const hoverSrc = swatch.getAttribute('data-hover');
  const hoverSrcset = swatch.getAttribute('data-hover-srcset');

  picture.classList.remove('is-swiped');

  if (!hoverSrc) {
    picture.classList.remove('has-card-swipe');

    const indicator = picture.querySelector('.card__swipe-indicator');
    if (indicator) indicator.remove();

    return;
  }

  hoverImage.src = hoverSrc;

  if (hoverSrcset && hoverSrcset.trim() !== '') {
    hoverImage.srcset = hoverSrcset;
  } else {
    hoverImage.removeAttribute('srcset');
  }

  picture.classList.add('has-card-swipe');
  addSwipeIndicator(picture);
}

async function afterCardAddToCart() {
  if (isCartPageForCardAdd()) {
    setTimeout(() => {
      window.location.reload();
    }, 350);
    return;
  }

  if (typeof window.refreshCartUI === 'function') {
    await window.refreshCartUI();
  }

  if (typeof window.closeCartDrawer === 'function') {
    window.closeCartDrawer();
  }
}

function isCartPageForCardAdd() {
  const path = window.location.pathname.replace(/\/$/, '');

  if (path === '/cart' || path === '/en/cart') {
    return true;
  }

  return !!document.querySelector(
    'cart-items.cart-page, #main-cart-items, form#cart, .wt-cart__wrapper.cart-page'
  );
}


/* Rebuild custom product-card features after collection AJAX filtering */
document.addEventListener('DOMContentLoaded', initProductGridRefreshObserver);
document.addEventListener('shopify:section:load', initProductGridRefreshObserver);

let productGridObserver = null;
let productGridContainerObserver = null;
let observedProductGrid = null;
let observedProductGridContainer = null;
let productGridRefreshTimer = null;

function initProductGridRefreshObserver() {
  bindProductGridRefreshObserver();

  setTimeout(bindProductGridRefreshObserver, 150);
  setTimeout(bindProductGridRefreshObserver, 500);
}

function bindProductGridRefreshObserver() {
  const productGrid = document.querySelector('#product-grid');
  const productGridContainer = document.querySelector('#ProductGridContainer');

  if (productGrid && productGrid !== observedProductGrid) {
    if (productGridObserver) productGridObserver.disconnect();

    observedProductGrid = productGrid;
    productGridObserver = new MutationObserver(handleProductGridMutation);

    productGridObserver.observe(productGrid, {
      childList: true
    });
  }

  if (productGridContainer && productGridContainer !== observedProductGridContainer) {
    if (productGridContainerObserver) productGridContainerObserver.disconnect();

    observedProductGridContainer = productGridContainer;
    productGridContainerObserver = new MutationObserver(handleProductGridMutation);

    productGridContainerObserver.observe(productGridContainer, {
      childList: true
    });
  }
}

function handleProductGridMutation(mutations) {
  const hasRelevantChange = mutations.some((mutation) => {
    return Array.from(mutation.addedNodes).some((node) => {
      if (node.nodeType !== 1) return false;

      return (
        node.matches?.('#product-grid, .collection__grid__item, .card__container') ||
        node.querySelector?.('.card__container')
      );
    });
  });

  if (!hasRelevantChange) return;

  clearTimeout(productGridRefreshTimer);

  productGridRefreshTimer = setTimeout(() => {
    initCardOverlayAdd();

    if (typeof initProductCardSwipe === 'function') {
      initProductCardSwipe();
    }

    bindProductGridRefreshObserver();
  }, 150);
}